import React, { useState } from "react";

const CustomTooltip = ({
    children,
    title,
    placement = "top",
    arrow = false,
    className = "",
    wrapperClassName = "inline-block",
}) => {
    const [open, setOpen] = useState(false);

    // Base tooltip styles
    const baseTooltip =
        "absolute z-50 whitespace-nowrap bg-gray-800 text-white text-xs px-2 py-3 rounded-xs shadow-xs flex justify-center items-center " +
        "transition-all duration-200 transform origin-center"; // 👈 transition + transform

    // Placement handling
    const placementStyles = {
        top: "-translate-x-1/2 -translate-y-full left-1/2 bottom-full mb-2 top-0",
        "top-start": "left-0 bottom-full mb-2",
        "top-end": "right-0 bottom-full mb-2",

        bottom: "-translate-x-1/2 translate-y-full left-1/2 top-full mt-2",
        "bottom-start": "left-0 top-full mt-2",
        "bottom-end": "right-0 top-full mt-2",

        left: "-translate-x-full -translate-y-1/2 right-full top-1/2 mr-2",
        "left-start": "right-full top-0 mr-2",
        "left-end": "right-full bottom-0 mr-2",

        right: "-translate-y-1/2 left-full top-1/2 ml-2",
        "right-start": "left-full top-0 ml-2",
        "right-end": "left-full bottom-0 ml-2",
    };

    // Arrow styles
    const arrowBase = "absolute w-2 h-2 bg-gray-800 rotate-45";

    const arrowPosition = {
        top: "bottom-[-4px] left-1/2 -translate-x-1/2",
        "top-start": "bottom-[-4px] left-2",
        "top-end": "bottom-[-4px] right-2",

        bottom: "top-[-4px] left-1/2 -translate-x-1/2",
        "bottom-start": "top-[-4px] left-2",
        "bottom-end": "top-[-4px] right-2",

        left: "right-[-4px] top-1/2 -translate-y-1/2",
        "left-start": "right-[-4px] top-2",
        "left-end": "right-[-4px] bottom-2",

        right: "left-[-4px] top-1/2 -translate-y-1/2",
        "right-start": "left-[-4px] top-2",
        "right-end": "left-[-4px] bottom-2",
    };

    return (
        <div
            className={`relative ${wrapperClassName}`}
            onMouseEnter={() => setOpen(true)}
            onMouseLeave={() => setOpen(false)}
        >
            {children}

            {open && (
                <div
                    className={`${baseTooltip} ${placementStyles[placement]} ${className} opacity-100 scale-100`}
                >
                    {title}
                    {arrow && (
                        <span
                            className={`${arrowBase} ${arrowPosition[placement]}`}
                        />
                    )}
                </div>
            )}
        </div>
    );
};

export default CustomTooltip;
